import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { BtnOutlineGreen, BtnOutlineRed } from '../../../styled-components';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';
import axios from 'axios';
import moment from 'moment';

function RequestSubscriptionButton({
  profile = {},
  subscriptionPlan = {},
  fetchProfileSubscriptions,
  subscriptions = [],
}) {
  const [t] = useTranslation('SUBSCRIPTIONS');
  const alert = useAlert();
  const [{ newIsAdmin, newToken } = {}] = useAuth();
  const { showLoading, hideLoading } = useLoading();
  const [requestSubscriptionModal, setRequestSubscriptionModal] = useState(
    false
  );
  const latestSubscription = subscriptions[0] || {};
  const isExpired = latestSubscription.expireDate
    ? moment
        .utc(latestSubscription.expireDate)
        .startOf('day')
        .isSameOrAfter(moment.utc().startOf('day'))
    : latestSubscription._id
    ? true
    : false;

  const toggle = () => {
    setRequestSubscriptionModal(!requestSubscriptionModal);
  };

  const onSubmit = async () => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/subscriptions/request/admin`,
      {},
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));
    toggle();
    fetchProfileSubscriptions();
  };

  return (
    <React.Fragment>
      <Button
        target="_blank"
        color="primary"
        style={{ marginTop: 0 }}
        disabled={isExpired}
        onClick={(event) => {
          event.stopPropagation();
          toggle();
        }}
      >
        {t('REQUEST_SUBSCRIPTION_BUTTON')}
      </Button>

      <Modal
        isOpen={requestSubscriptionModal}
        toggle={toggle}
        className="new-file-modal"
      >
        <ModalHeader toggle={toggle}>
          {t('REQUEST_SUBSCRIPTION_TITLE')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <ModalBody>
            <div className="max-width-form" style={{ textAlign: 'center' }}>
              Il costo dell'abbonamento é pari a {subscriptionPlan.cost} €
              annuali. Sei sicuro di voler richiedere un abbonamento?
            </div>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default RequestSubscriptionButton;
